export enum PropertyServicesParkingEnum {
	'garage' = 'Garage',
	'allocated_space' = 'Allocated space',
	'permit' = 'Permit',
	'roadway' = 'Roadway',
	'driveway' = 'Driveway',
}
